/* eslint no-underscore-dangle: ["error", { "allow": ["_d"] }] */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';

// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from '../Order.sass';
import s2 from './Order10PickupTime.sass';
import s3 from '../../../assets/styles/style.sass';
import {
  updateOrderDetailInfoAction,
  setIsValidOrder,
} from '../../../actions/order';
import { dateToISO8601String } from '../../../service/util';

class Order10PickupTime extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    isClickConfirmOrder: PropTypes.bool.isRequired,
    setIsValidOrder: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    let langType = props.currentLocale.split('-')[0]; // en-SG
    let langTypeE = props.currentLocale.split('-')[0]; // en-SG
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    if (lang === 'hk') {
      langTypeE = `${langType}-${lang}`;
      langType = langTypeE;
    } else if (['sg', 'in'].includes(lang)) {
      langTypeE = 'en';
      langType = lang;
    } else {
      langTypeE = lang;
      langType = lang;
    }
    this.state = {
      timeModal: false,
      dateModal: false,
      now: new Date(),
      selectedTime: 0,
      selectedDate: 0,
      pickupDate: new Date(), // the date user picked
      isValidTime: true,
      isEN: props.currentLocale.split('-')[0].toLowerCase(), // for show today in Pickup
      modelData: require(`../../../assets/src/scripts/gogovan/order/${lang}/${langType}-modelData.json`),
    };
    this.timeModal = [];
    this.timeModalToggle = this.timeModalToggle.bind(this);
    this.dateModalToggle = this.dateModalToggle.bind(this);
    this.getSelectedDate = this.getSelectedDate.bind(this);
    this.getSelectedTime = this.getSelectedTime.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.setPickupDate = this.setPickupDate.bind(this);
    this.setPickupTime = this.setPickupTime.bind(this);
  }

  componentWillMount() {
    this.setState({ selectedTime: this.getSelectedTime() });
    this.setState({ selectedDate: this.getSelectedDate() });
    this.setPickupDate(this.state.now);
    const h = this.getSelectedTime().split(':')[0];
    const m = this.getSelectedTime().split(':')[1];
    this.setPickupTime(h, m);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
      if (this.state.pickupDate < Date.now()) {
        this.setState({ isValidTime: false });
        this.props.setIsValidOrder(false);
      } else {
        this.setState({ isValidTime: true });
      }
    }
  }

  getSelectedDate() {
    return this.state.now
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, '/');
  }

  getSelectedTime() {
    let h = this.state.now.getHours();
    let m = Math.floor(this.state.now.getMinutes() / 10) * 10 + 20;
    if (m >= 60) {
      h = this.state.now.getHours() + 1;
    }
    m %= 60;
    if (m === 0) {
      m = '00';
    }
    return `${h}:${m}`;
  }

  setPickupDate(date) {
    this.state.pickupDate.setMonth(date.getMonth());
    this.state.pickupDate.setDate(date.getDate());
    this.state.pickupDate.setFullYear(date.getFullYear());
    this.props.updateOrderDetailInfoAction(
      'pickup_time',
      null,
      dateToISO8601String(this.state.pickupDate),
    );
  }
  setPickupTime(h, m) {
    this.state.pickupDate.setHours(h);
    this.state.pickupDate.setMinutes(m);
    this.state.pickupDate.setSeconds(0);
    this.state.pickupDate.setMilliseconds(0);
    this.props.updateOrderDetailInfoAction(
      'pickup_time',
      null,
      dateToISO8601String(this.state.pickupDate),
    );
  }
  handleDate(e) {
    const d = new Date(e._d);
    this.setState({ now: new Date(d.setDate(d.getDate() + 1)) }, () => {
      this.setState({ selectedDate: this.getSelectedDate() });
      this.setPickupDate(e._d);
      this.dateModalToggle();
    });
  }

  dateModalToggle() {
    this.setState({
      dateModal: !this.state.dateModal,
    });
  }
  timeModalToggle() {
    // scroll To selected Time
    if (!this.state.timeModal) {
      setTimeout(() => {
        this.timeModal[this.state.selectedTime].scrollIntoView();
      }, 500);
    }
    this.setState({
      timeModal: !this.state.timeModal,
    });
  }
  render() {
    const timePopup = [];
    for (let i = 0; i <= 23; i += 1) {
      for (let j = 0; j < 60; j += 10) {
        if (j === 0) {
          timePopup.push(
            <span
              key={`${i}:00`}
              id={`${i}:00`}
              ref={input => {
                this.timeModal[`${i}:00`] = input;
              }}
              role="button"
              tabIndex={0}
              className={`${s2.picker__listItem}`}
              style={
                this.state.selectedTime === `${i}:00`
                  ? { background: '#0089ec', color: '#fff' }
                  : {}
              }
              onClick={() => {
                this.setState({ selectedTime: `${i}:00` }, () => {
                  const h = this.state.selectedTime.split(':')[0];
                  const m = this.state.selectedTime.split(':')[1];
                  this.setPickupTime(h, m);
                });
                this.timeModalToggle();
              }}
              onKeyPress={() => {}}
            >{`${i}:00`}</span>,
          );
        } else {
          timePopup.push(
            <span
              key={`${i}:${j}`}
              id={`${i}:${j}`}
              ref={input => {
                this.timeModal[`${i}:${j}`] = input;
              }}
              role="button"
              tabIndex={0}
              className={`${s2.picker__listItem}`}
              style={
                this.state.selectedTime === `${i}:${j}`
                  ? { background: '#0089ec', color: '#fff' }
                  : {}
              }
              onClick={() => {
                this.setState({ selectedTime: `${i}:${j}` }, () => {
                  const h = this.state.selectedTime.split(':')[0];
                  const m = this.state.selectedTime.split(':')[1];
                  this.setPickupTime(h, m);
                });
                this.timeModalToggle();
              }}
              onKeyPress={() => {}}
            >{`${i}:${j}`}</span>,
          );
        }
      }
    }
    return (
      <div>
        <div className={s.orderSmallTitle}>
          {this.props.modelDataText.pick_up_time_title}
        </div>
        <Row>
          <Col xs="12" sm="12" md="6">
            <select
              className={`${s.inputSelect} ${s.backgroundDark} ${
                s.simpleSelectDropdown
              } ${s.icon} ${s3.orderSelectHover} col-12`}
              ref={input => {
                this.dateModal = input;
              }}
              onClick={() => {
                this.dateModal.blur();
                this.dateModalToggle();
              }}
            >
              <option className={`${s2.optionHidden}`}>
                {this.state.selectedDate}
              </option>
            </select>
          </Col>
          <Col xs="12" sm="12" md="6">
            <select
              className={`${s.inputSelect} ${s.backgroundDark} ${
                s.simpleSelectDropdown
              } ${s.icon} ${s3.orderSelectHover} col-12`}
              ref={input => {
                this.timeModal = input;
              }}
              onClick={() => {
                this.timeModal.blur();
                this.timeModalToggle();
              }}
            >
              <option className={`${s2.optionHidden}`}>
                {this.state.selectedTime}
              </option>
            </select>
          </Col>

          <p
            className={`${s3.globalTextRed} ${s3.globalFontNormal} ${
              s.orderWarningText
            }`}
            style={!this.state.isValidTime ? {} : { display: 'none' }}
          >
            {this.props.modelDataText.pickup_datetime_input_warning}
          </p>

          {/* Date Picker */}
          <Modal
            className={`${s2.infoPopup} `}
            isOpen={this.state.dateModal}
            toggle={this.dateModalToggle}
            size="lg"
          >
            <ModalBody style={{ height: '380px', overflowY: 'auto' }}>
              <Datetime
                locale={this.props.currentLocale}
                className={s2.picker__dateTime}
                input={false}
                timeFormat={false}
                onChange={this.handleDate}
                // renderDay={(props, currentDate) => {
                //   if (
                //     new Date().getMonth() === currentDate.month() &&
                //     new Date().getDate() === currentDate.date()
                //   ) {
                //     return (
                //       <td
                //         {...props}
                //         className={`${s2.calenderHover} ${s2.calenderToday}`}
                //       >
                //         {currentDate.date()}
                //       </td>
                //     );
                //   }
                //   return (
                //     <td {...props} className={`${s2.calenderHover}`}>
                //       {currentDate.date()}
                //     </td>
                //   );
                // }}
              />
              <div style={{ textAlign: 'center' }}>
                <Button
                  color="link"
                  className={s2.pickerTodayButton}
                  onClick={() => {
                    this.setPickupDate(new Date());
                    const today = new Date()
                      .toISOString()
                      .slice(0, 10)
                      .replace(/-/g, '/');
                    this.setState({ selectedDate: today });
                    this.dateModalToggle();
                  }}
                >
                  {this.state.modelData.order_model_data.datepicker.date.today}
                  &nbsp;&nbsp;
                  {this.state.isEN === 'en'
                    ? new Date()
                        .toISOString()
                        .slice(0, 10)
                        .replace(/-/g, '/')
                    : ''}
                </Button>
                <Button
                  color="link"
                  className={s2.pickerClosedButton}
                  onClick={() => {
                    this.dateModalToggle();
                  }}
                >
                  {this.state.modelData.order_model_data.datepicker.date.close}
                </Button>
              </div>
            </ModalBody>
          </Modal>
          {/* Time Picker */}
          <Modal
            className={`${s2.infoPopup} `}
            contentClassName={`${s2.picker__frame} ${s2.picker__wrap}`}
            size="sm"
            isOpen={this.state.timeModal}
            toggle={this.timeModalToggle}
          >
            <ul>{timePopup}</ul>
          </Modal>
        </Row>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  pickup_time: state.order.pickup_time,
  isClickConfirmOrder: state.order.isClickConfirmOrder,
});

const mapDispatch = {
  setIsValidOrder,
  updateOrderDetailInfoAction,
};

export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s3, s, s2)(Order10PickupTime),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order10PickupTime/Order10PickupTime.js